import { render } from "./StepThreeRegistration.vue?vue&type=template&id=629e5ebf&scoped=true"
import script from "./StepThreeRegistration.vue?vue&type=script&lang=js"
export * from "./StepThreeRegistration.vue?vue&type=script&lang=js"

import "./StepThreeRegistration.vue?vue&type=style&index=0&id=629e5ebf&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629e5ebf"]])

export default __exports__